import React from 'react';
import { CssBaseline } from '@material-ui/core';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import Registration from './Registration';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#23527c',
    },
    secondary: {
      main: '#A9C78B',
    },
  },
});

const handleSubmit = async values => {
  const url = window._NZACA_EVENTS_FORM_URL;
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...values, EventID: window._NZACA_EVENTS_EVENTID }),
  });
  const result = await response.text();
  if (result && result.length < 255) {
    window.location = result;
  } else {
    console.log(result);
  }
};

const App = () => (
  <div style={{ padding: 16, margin: 'auto', maxWidth: 600 }}>
    <CssBaseline/>
    <MuiThemeProvider theme={theme}>
      <Registration onSubmit={handleSubmit}/>
    </MuiThemeProvider>
  </div>
);

export default App;
